import { render, staticRenderFns } from "./AdminStaffList.vue?vue&type=template&id=616e16d9"
import script from "./AdminStaffList.vue?vue&type=script&lang=js"
export * from "./AdminStaffList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports